import React, { useState, useEffect } from 'react'
import { Bar } from 'react-chartjs-2'
import { Alert, AlertTitle } from '@material-ui/lab';
import { addCommas } from './../../addComas'
import { sortDataByKey } from './../../addComas'
import { db } from './../../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';


function sizeBar(phone) {
    if (phone) {
        return null
    } else {
        return 45
    }
}

function Exportaciones({ phone }) {
    //Get Data from firebase
    const [min, setMin] = useState(null)
    const [nomin, setNo] = useState(null)
    const [total, setTot] = useState(null)
    const [grow, setGrow] = useState(null)

    const ready = () => {
        if (min && nomin && total && grow) {
            return true
        } else {
            return false
        }
    }
    useEffect(() => {
        //Carga Mineros
        db.collection('Pruebas').doc('EXP')
            .collection('TOTALES').doc('Mineros')
            .onSnapshot(snapshot => {
                setMin(sortDataByKey(snapshot.data()))
            });
        //Carga No Mineros
        db.collection('Pruebas').doc('EXP')
            .collection('TOTALES').doc('No Mineros')
            .onSnapshot(snapshot => {
                setNo(sortDataByKey(snapshot.data()))
            });
        //Carga Totales
        db.collection('Pruebas').doc('EXP')
            .collection('TOTALES').doc('Total')
            .onSnapshot(snapshot => {
                setTot(sortDataByKey(snapshot.data()))
            });
        //Carga Crecimientos
        db.collection('Pruebas').doc('EXP')
            .collection('TOTALES').doc('crecimientos')
            .onSnapshot(snapshot => {
                setGrow(sortDataByKey(snapshot.data()))
            });
    }, [])

    useEffect(() => {
        ready() && chart()
    }, [min, nomin, total, grow])



    const options = {
        scales: {
            xAxes: [{
                stacked: true,
                barThickness: sizeBar(phone),
                gridLines: { display: false }

            }],
            yAxes: [{
                stacked: true,
                borderWidth: 1,
                borderColor: "#111111",
                gridLines: {
                    zeroLineWidth: 2,
                    zeroLineColor: '#111111',
                    lineWidth: 0,
                },
                ticks: {
                    callback: (value) => { return addCommas(value) },
                    max: phone ? 80000 : 70000,

                },

            }],

        },
        responsive: true,
        scaleFontColor: '#111111',
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    return data.datasets[tooltipItem.datasetIndex].label + ': ' + addCommas(tooltipItem.value);
                }
            }
        },
        plugins: {

        }
    }
    const [chartData, setChartData] = useState({})
    const chart = () => {
        setChartData({
            labels: Object.keys(nomin),
            datasets: [
                {
                    label: "No Mineras",
                    data: Object.values(nomin),
                    backgroundColor: "#f79824",
                    borderColor: "#111111",
                    borderWidth: 1,
                    datalabels: {
                        display: !phone,
                        color: '#fff',
                        align: 'center',
                        formatter: (value) => {
                            return addCommas(value)
                        },

                    }
                },
                {
                    label: "Mineras",
                    data: Object.values(min),
                    backgroundColor: "#2176ff",
                    borderColor: "#111111",
                    borderWidth: 1,
                    datalabels: {
                        display: !phone,
                        color: '#fff',
                        align: 'center',
                        formatter: (value) => {
                            return addCommas(value)
                        },

                    }
                },
                {
                    label: "Total",
                    data: Object.values(total),
                    backgroundColor: "#fafafa",
                    borderColor: "#111111",
                    borderWidth: 0,
                    datalabels: {
                        display: true,
                        color: '#111111',
                        align: phone ? 'center' : 'start',
                        formatter: (value) => {
                            return addCommas(value)
                        },

                    }
                }

            ]

        })
    }

    const alertColor = (x) => {
        if (x > 0) {
            return "success"
        } else {
            return "error"
        }
    }
    return (


        <div className="chart">
            <h3 className="chart-title">
                Exportaciones (USD millones FOB)
                </h3>

            {ready() ? (
                [<Bar data={chartData} options={options} />,
                <Alert severity={alertColor(grow.total)} icon={false}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column'

                    }}>
                    <AlertTitle>Tasa de crecimiento {grow.periodo}</AlertTitle>
                Total: <strong>{String(grow.total).replace(".", ",")}%</strong> No mineras: <strong>{String(grow.noMineras).replace(".", ",")}%</strong>
                </Alert>
                ]
            ) : (
                    <CircularProgress color="secondary"></CircularProgress>
                )}


        </div>


    )
}

export default Exportaciones
